import React, { useMemo } from 'react';
import { ImageField, TextInput, useTranslate } from 'react-admin';
import { useLocation } from 'react-router-dom';

import { List, Show, Create, Edit } from '../../common/ra';
import ResourceTitle from '../../common/ResourceTitle';
import { ShowHeader } from '../../common/ShowHeader';
import { OfficeTypeEnumInput } from '../../common/inputs/EnumInputs';

import { OfficeGrid } from './OfficeGrid';
import { OfficeShowLayout } from './OfficeShow';
import { OfficeForm } from './OfficeForm';
import { OfficeField } from './OfficeField';
import { OfficeActions } from './OfficeActions';

export const OfficeShowHeader = () => {
  const translate = useTranslate()
  return <ShowHeader
    name={office => office.name}
    type={office => `${translate('resources.offices.name', 1)} - ${translate(`resources.offices.values.type.${office.type}`, { _: office.type })}`}
    description={office => <OfficeField source="parentId" variant="inherit" />}
    avatar={office => <ImageField source="logoUrl" />} />;
}

export const OfficeList = props =>
  <List {...props}
    filters={[
      <TextInput source="name" variant="outlined" alwaysOn />,
      <OfficeTypeEnumInput source="type" variant="outlined" alwaysOn multiple />,
    ]}
    sort={{
      field: 'name',
      order: 'ASC'
    }}
  >
    <OfficeGrid rowClick="show" />
  </List>

export const OfficeShow = props => {
  const location = useLocation();
  const officeTab = useMemo(() => {
    return location?.pathname?.substring(location.pathname.lastIndexOf('/') + 1)
  }, [ location.pathname ])

  return <Show {...props}
    title={<OfficeShowHeader />}
    className={['scheduler', 'association-scheduler'].includes(officeTab) ? 'scheduler-tab-show' : ''}
    actions={<OfficeActions />}
  >
    <OfficeShowLayout />
  </Show>
}

export const OfficeCreate = props => {
  const translate = useTranslate()
  return <Create
    title={<ResourceTitle title={record => translate('resources.offices.labels.add')} />}
    {...props}
  >
    <OfficeForm redirect="show" />
  </Create>
}

export const OfficeEdit = props => {
  const translate = useTranslate()
  return <Edit
    title={<ResourceTitle title={record => translate('ra.page.editing', { name: record.name })} />}
    {...props}
  >
    <OfficeForm redirect="show" />
  </Edit>
}
